import axios from 'axios';
import { PRICElIST_BASE_URL } from '../BaseURL';
import getHeaders from '../../constants/headers';

export const getStoreDefaultPrice = (storeId) => {
  return axios({
    method: 'get',
    url:
      PRICElIST_BASE_URL + '/api/secure/v1/store/' + storeId + '/default-price',
    headers: getHeaders(),
  });
};
